export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Help Improve Central!"])},
        "introduction": [
          {
            "full": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["In the ", _interpolate(_named("usageReporting")), " tab in System Settings, you can choose to share anonymized usage data or contact information with the Central team."])},
            "usageReporting": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Usage Reporting"])}
          },
          (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["There, you can also choose to not see this message again."])},
          
        ],
        "action": {
          "improveCentral": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Improve Central"])}
        }
      }
    }
  })
}
